import secureApi from "../services/secureApi";

export const getMaterials = async ({ search = "", sort = "desc" } = {}) => {
  try {
    const params = { sort };

    if (search?.trim()) {
      params.search = search.trim();
    }

    const response = await secureApi.get("/admin/material/list", {
      params,
    });

    return response.data;
  } catch (error) {
    console.error("GET MATERIALS ERROR", error);
    throw error;
  }
};

export const addMaterial = async (data) => {
  try {
    const response = await secureApi.post(
      "/admin/material/add",
      data
    );

    return response.data;
  } catch (error) {
    console.error("ADD MATERIAL ERROR", error);
    throw error;
  }
};

export const getMaterialById = async (id) => {
  try {
    const response = await secureApi.get(
      `/admin/material/view/${id}`
    );

    return response.data;
  } catch (error) {
    console.error("GET MATERIAL ERROR", error);
    throw error;
  }
};

export const getEditMaterial = async (id, data) => {
  try {
    const response = await secureApi.put(
      `/admin/material/edit/${id}`,
      data
    );

    return response.data;
  } catch (error) {
    console.error("GET EDIT MATERIAL ERROR", error);
    throw error;
  }
};

export const deleteMaterial = async (id) => {
  try {
    const response = await secureApi.delete(
      `/admin/material/delete/${id}`
    );

    return response.data;
  } catch (error) {
    console.error("DELETE MATERIAL ERROR", error);
    throw error;
  }
};